// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"bd","newsItemBox":"bd","img-box":"be","imgBox":"be","img-mask-box":"bf","imgMaskBox":"bf"};